const styles = theme => ({
    'root': {
        height: '100%',
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
    },
    'subheader': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        fontWeight: 'bold'
    },
    'buttons': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        fontWeight: 'bold'
    },
    'parentLink': {
        paddingTop: 2,
        paddingBottom: 2
    },
    'nested': {
        paddingLeft: theme.spacing(4),
        paddingTop: 2,
        paddingBottom: 2
    },
    'nestedIcon': {
        marginRight: 0,
    },
});

export default styles;